// businessPlanTelegramService.js
const TELEGRAM_BOT_TOKEN = "7918152804:AAEfqKOSPdTW26F1OpWBhn3onVP3pk-6Jgs";
const TELEGRAM_CHAT_ID = "-4831361896";

function escapeMarkdown(text) {
  if (!text) return "N/A";
  return text.replace(/[_*[\]()~`>#+-=|{}.!]/g, (match) => `\\${match}`);
}

async function sendTelegramMessage(token, chatId, message) {
  console.log("Sending Telegram message:", { token: token.substring(0, 10) + "...", chatId, message });
  
  const response = await fetch(
    `https://api.telegram.org/bot${token}/sendMessage`,
    {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        chat_id: chatId,
        text: message,
        parse_mode: "MarkdownV2",
        disable_notification: true,
      }),
    }
  );
  
  const data = await response.json();
  console.log("Telegram sendMessage response:", data);
  
  if (!data.ok) {
    throw new Error(data.description);
  }
  return data;
}

async function sendBusinessPlanToTelegram(name, email, businessPlan, workflowData) {
  console.log("sendBusinessPlanToTelegram called with:", { name, email, businessPlan, workflowData });
  
  const currentDateTime = new Date().toLocaleString("en-IN", {
    timeZone: "Asia/Kolkata",
  });

  // Create a summary of the workflow
  const nodeTypes = workflowData.nodes.reduce((acc, node) => {
    acc[node.type] = (acc[node.type] || 0) + 1;
    return acc;
  }, {});

  const workflowSummary = Object.entries(nodeTypes)
    .map(([type, count]) => `${type}: ${count}`)
    .join(', ') || 'None';

  const message = [
    `*New Business Plan Submission*`,
    `*Name:* ${escapeMarkdown(name)}`,
    `*Email:* ${escapeMarkdown(email)}`,
    `*Date and Time:* ${escapeMarkdown(currentDateTime)}`,
    `*Business Plan:* ${escapeMarkdown(businessPlan)}`,
    `*Workflow Summary:* ${escapeMarkdown(workflowSummary)}`,
    `*Node Count:* ${workflowData.nodes.length}`,
    `*Edge Count:* ${workflowData.edges.length}`,
    `*Group Count:* ${workflowData.groups.length}`,
  ].join("\n");

  try {
    // Send the business plan submission message first
    console.log("Sending business plan message to Telegram");
    const data = await sendTelegramMessage(TELEGRAM_BOT_TOKEN, TELEGRAM_CHAT_ID, message);
    console.log("Telegram business plan message sent:", data);
    
    // Send the full workflow as a document
    console.log("Sending workflow document to Telegram");
    const workflowJson = JSON.stringify(workflowData, null, 2);
    const blob = new Blob([workflowJson], { type: 'application/json' });
    
    const formData = new FormData();
    formData.append('chat_id', TELEGRAM_CHAT_ID);
    formData.append('document', blob, `business-plan-workflow-${Date.now()}.json`);
    formData.append('caption', `Business plan workflow for ${escapeMarkdown(name)} (${escapeMarkdown(email)})`);
    
    const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendDocument`, {
      method: 'POST',
      body: formData
    });
    
    const documentData = await response.json();
    console.log("Telegram document send response:", documentData);
    
    if (!documentData.ok) {
      console.error("Error sending workflow document:", documentData.description);
      throw new Error(documentData.description);
    } else {
      console.log("Telegram workflow document sent:", documentData);
    }
    
    return true;
  } catch (error) {
    console.error("Error sending Telegram message:", error);
    throw error;
  }
}

export { sendBusinessPlanToTelegram };